import withSharedStyles from "../theme/Shared.style";

// Detail template: two columns 7/5 — gallery left, sticky buy box right.
// Stacks under 1100px. Rails below.
const withCustomStyles = withSharedStyles(theme => {
  const { color, radius, fontSize, shadow } = theme.tokens;
  const stickyTop = theme.layout.headerHeight + 24;

  return {
    page: {
      ...theme.mixins.page
    },
    top: {
      display: "flex",
      flexDirection: "column",
      gap: 24
    },
    stack: {
      display: "flex",
      flexDirection: "column",
      gap: theme.layout.sectionGap,
      minWidth: 0
    },
    detail: {
      display: "grid",
      gridTemplateColumns: "7fr 5fr",
      gap: 48,
      alignItems: "start",
      [theme.media.belowDesktop]: {
        gridTemplateColumns: "1fr",
        gap: 24
      }
    },

    // Gallery
    gallery: {
      display: "flex",
      flexDirection: "column",
      gap: 12,
      minWidth: 0
    },
    galleryMain: {
      position: "relative",
      aspectRatio: "1 / 1",
      maxHeight: 640,
      borderRadius: radius.card,
      backgroundColor: color.surface,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflow: "hidden",
      [theme.media.belowDesktop]: { maxHeight: 520 }
    },
    galleryMainSkeleton: {
      aspectRatio: "1 / 1",
      height: "auto !important",
      minHeight: 280,
      borderRadius: `${radius.card}px !important`
    },
    galleryImage: {
      width: "76%",
      height: "76%",
      objectFit: "contain",
      mixBlendMode: "multiply"
    },
    isOut: {
      "& $galleryImage": { opacity: 0.45 }
    },
    discount: {
      position: "absolute",
      top: 16,
      left: 16,
      backgroundColor: color.deal,
      color: color.bg,
      fontSize: fontSize.ui,
      fontWeight: 700,
      padding: "6px 10px",
      borderRadius: radius.badge
    },
    outLabel: {
      position: "absolute",
      left: 16,
      bottom: 16,
      backgroundColor: color.bg,
      color: color.text2,
      fontSize: fontSize.ui,
      fontWeight: 700,
      padding: "6px 10px",
      borderRadius: radius.badge
    },
    thumbs: {
      display: "flex",
      gap: 8,
      overflowX: "auto",
      scrollbarWidth: "none",
      "&::-webkit-scrollbar": { display: "none" }
    },
    thumb: {
      appearance: "none",
      border: 0,
      padding: 6,
      cursor: "pointer",
      flex: "none",
      width: 72,
      height: 72,
      borderRadius: radius.field,
      backgroundColor: color.surface,
      "& img": {
        width: "100%",
        height: "100%",
        objectFit: "contain",
        mixBlendMode: "multiply"
      }
    },
    thumbActive: {
      boxShadow: shadow.selected
    },

    // Buy box
    buyBox: {
      position: "sticky",
      top: stickyTop,
      display: "flex",
      flexDirection: "column",
      gap: 8,
      minWidth: 0,
      [theme.media.belowDesktop]: { position: "static" }
    },
    brandLine: {
      fontSize: fontSize.ui,
      fontWeight: 600,
      color: color.muted,
      "& a": { color: color.text2, textDecoration: "none" },
      "& a:hover": { color: color.brandText }
    },
    productName: {
      margin: 0,
      fontSize: fontSize.h1,
      fontWeight: 800,
      letterSpacing: "-0.01em",
      lineHeight: 1.2,
      color: color.ink,
      [theme.media.phone]: { fontSize: fontSize.mobile.h1 }
    },
    pack: {
      fontSize: fontSize.body,
      color: color.muted
    },
    priceRow: {
      display: "flex",
      alignItems: "baseline",
      flexWrap: "wrap",
      gap: 10,
      marginTop: 8
    },
    price: {
      fontSize: fontSize.price,
      fontWeight: 800,
      color: color.ink
    },
    was: {
      fontSize: fontSize.body,
      color: color.muted,
      textDecoration: "line-through"
    },
    actions: {
      display: "flex",
      flexDirection: "column",
      gap: 8,
      marginTop: 16
    },
    infoRows: {
      display: "flex",
      flexDirection: "column",
      marginTop: 16,
      paddingTop: 8,
      boxShadow: `inset 0 1px 0 ${color.line}`,
      "& > *": { marginLeft: -12, width: "calc(100% + 24px)" }
    },

    // About
    about: {
      display: "flex",
      flexDirection: "column",
      gap: theme.layout.titleGap,
      maxWidth: theme.layout.readingColumn
    },
    sectionTitle: {
      margin: 0,
      fontSize: fontSize.h2,
      fontWeight: 800,
      letterSpacing: "-0.01em",
      color: color.ink,
      [theme.media.phone]: { fontSize: fontSize.mobile.h2 }
    },
    aboutText: {
      margin: 0,
      fontSize: fontSize.body,
      lineHeight: 1.6,
      color: color.text2
    },
    specs: {
      margin: 0,
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
      gap: 12,
      "& > div": {
        padding: "14px 16px",
        borderRadius: radius.tile,
        backgroundColor: color.surface
      },
      "& dt": { fontSize: fontSize.small, color: color.muted },
      "& dd": {
        margin: "2px 0 0",
        fontSize: fontSize.body,
        fontWeight: 700,
        color: color.ink
      }
    }
  };
});

export default withCustomStyles;
